module.exports = __webpack_public_path__ + "static/media/gif2.273788a4.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banners/gifHome/gif2.gif
// module id = 203
// module chunks = 0